import { IPerformanceSection } from './PerformanceSection.interface';

export const initialState: IPerformanceSection = {
  ranking: { position: 0, totalPoints: 0 },
  postsByNetwork: { facebook: 0, linkedin: 0, twitter: 0, instagram: 0 },
  potentialReach: 0,
  estimatedReach: 0,
  totalPublishedPosts: 0,
  totalParticipatedCampaigns: 0,
  totalInvitedCampaigns: 0,
  monthlyRanking: { position: 0, totalPoints: 0 },
  annualRanking: { position: 0, totalPoints: 0 },
  dataFacebook: {
    postsProcessed: 0,
    totalLikes: 0,
    totalComments: 0,
    totalShares: 0,
    averageLikes: 0,
    averageComments: 0,
    averageShares: 0,
    albumFacebook: []
  },
  dataInstagram: {
    postsProcessed: 0,
    totalLikes: 0,
    totalComments: 0,
    totalShares: 0,
    totalReach: 0,
    totalSaved: 0,
    totalViews: 0,
    averageLikes: 0,
    averageComments: 0,
    averageShares: 0,
    albumInstagram: []
  }
};
